import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/info',
    name: 'UserInfo',
    component: () => import('@/views/UserInfo.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/status',
    name: 'Status',
    component: () => import('@/views/Status.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/my-info',
    name: 'MyInfo',
    component: () => import('@/views/MyInfo.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const userInfoStr = localStorage.getItem('userInfo')

  if (to.meta.requiresAuth) {
    if (!token || !userInfoStr) {
      next('/login')
      return
    }
  }

  // 已登录用户访问登录页则重定向
  if (to.path === '/login' && token && userInfoStr) {
    try {
      const profile = JSON.parse(userInfoStr)
      if (profile.workerStatus === 'unfilled') {
        next('/info')
        return
      } else if (profile.workerStatus === 'normal') {
        next('/my-info')
        return
      } else {
        next('/status')
        return
      }
    } catch (e) {
      // userInfo 解析失败，清除并重新登录
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    }
  }

  next()
})

export default router